import {Component, OnInit} from '@angular/core';
import {HttpService} from "../../services/http/http.service";
import {MatDialog} from "@angular/material/dialog";
import {CommonsService} from "../../services/commons/commons.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {
  DetailCompetenzaDialog
} from "../../pages/ricerca-profili-competenze/detail-competenze/detail-competenza.component";
import {DetailProfiloDialog} from "../../pages/ricerca-profili-competenze/detail-profilo/detail-profilo.component";

@Component({
  selector: 'atlante-profili-competenze',
  templateUrl: './atlante-profili-competenze.component.html',
  styleUrls: ['./atlante-profili-competenze.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({height: '*', opacity: 1, transform: 'translateY(2)'})),
      state('out', style({height: '0px', opacity: 0, transform: 'translateY(-10)', overflow: 'hidden'})),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class AtlanteProfiliCompetenzeComponent implements OnInit {
  tipologieArea: any = [];
  competenze: any = [];
  mapTipologiaAreaIdToProfili = new Map<number, any[]>();
  mapIdPropostaToCompetenze = new Map<number, any[]>();
  mapCompetenzaIdToAbilita = new Map<number, any[]>();
  mapCompetenzaIdToConoscenza = new Map<number, any[]>();
  fetchedContent = false;

  tipoAreaProfilo: any;
  descrizioneProfilo: string;

  // Toggle per Green e Digital
  isGreen: boolean = false;
  isDigital: boolean = false;

  // Ordinamento aree
  tipoOrdinamento: 'id' | 'alfabetico' = 'id';

  areas: any;

  constructor(
    public api: HttpService,
    public dialog: MatDialog,
    private commons: CommonsService,
  ) {
  }

  get atLeastOneFilterInserted() {
    return !this.descrizioneProfilo;
  }

  ngOnInit(): void {
    this.api.getTAreaProfilo().subscribe({
      next: (response: any) => {
        this.areas = response.result;
        this.tipologieArea = response.result;
        this.ordinaAree();
        this.fetchedContent = true;
      }
    })
  }

  handleAreaChange(item: any) {
    this.tipologieArea = [...item];
    this.tipoAreaProfilo = item;
  }

  // Gestione toggle - quando uno viene attivato, l'altro si disattiva
  onDigitalToggleChange() {
    if (this.isDigital) {
      this.isGreen = false;
    }
    this.filterSearch();
  }

  onGreenToggleChange() {
    if (this.isGreen) {
      this.isDigital = false;
    }

    this.filterSearch();
  }

  emptyCachedData() {
    this.areas.forEach((el: any) => {
      el.showChild = false;
      el.quered = false;
    })
    this.mapTipologiaAreaIdToProfili.clear();
    this.mapIdPropostaToCompetenze.clear();
    this.mapCompetenzaIdToAbilita.clear();
    this.mapCompetenzaIdToConoscenza.clear();
  }

  reset() {
    this.emptyCachedData()
    this.tipologieArea = [...this.areas];
    this.tipoAreaProfilo = null;
    this.descrizioneProfilo = "";
    // Reset anche i toggle
    this.isGreen = false;
    this.isDigital = false;
    // Reset ordinamento
    this.tipoOrdinamento = 'id';
    this.ordinaAree();
  }


  getProfilesByTipologia(tipoAreaProfilo: any) {
    if (tipoAreaProfilo.showChild || tipoAreaProfilo.quered) {
      tipoAreaProfilo.showChild = !tipoAreaProfilo.showChild;
      return;
    }

    const {descrizioneProfilo, isGreen, isDigital} = this
    this.api.ricercaProfiliProfessionali({
      descrizioneProfilo,
      tipoAreaProfilo,
      hasGreenCompetence: isGreen,
      hasDigitalCompetence: isDigital
    }, 0, 100)
      .subscribe({
        next: (response: any) => {
          this.mapResult(this.mapTipologiaAreaIdToProfili, response.result.listaProfili, tipoAreaProfilo.id);
          tipoAreaProfilo.showChild = true;
          tipoAreaProfilo.quered = true;

        }
      })
  }

  getCompetenzeByIdProposta(profilo: any) {
    if (profilo.showChild || profilo.quered) {
      profilo.showChild = !profilo.showChild;
      return;
    }

    const payload = {
      idProposta: profilo.idProposta,
      hasGreenCompetence: this.isGreen,
      hasDigitalCompetence: this.isDigital
    }

    this.commons.getCompetenzeByPropostaIdAndTipologiaIdAndDescrizione(payload).subscribe({
      next: (response: any) => {
        this.mapResult(this.mapIdPropostaToCompetenze, response.result, profilo.idProposta);

        profilo.showChild = true;
        profilo.quered = true;
      }
    })
  }

  getAbilitaConoscenze(competenza: any) {
    if (competenza.showChild || competenza.quered) {
      competenza.showChild = !competenza.showChild;
      return;
    }
    this.commons.getAbilitaByCompetenza(competenza.id).subscribe({
      next: (response: any) => {
        this.mapResult(this.mapCompetenzaIdToAbilita, response.result, competenza.id);
        competenza.showChild = true;
        competenza.quered = true;

      }
    })

    this.commons.getConoscenzeByCompetenza(competenza.id).subscribe({
      next: (response: any) => {
        this.mapResult(this.mapCompetenzaIdToConoscenza, response.result, competenza.id);

        competenza.showChild = true;
        competenza.quered = true;
      }
    })
  }

  mapResult(map: Map<number, any[]>, toMap: any[], mapKey: number) {
    let mapValues = map.get(mapKey);
    if (!mapValues) {
      mapValues = [...toMap];
      map.set(mapKey, mapValues);
    }
  }

  filterSearch() {
    this.emptyCachedData();
    const {tipoAreaProfilo, descrizioneProfilo, isGreen, isDigital} = this;

    this.commons.getTipologiaAreaProfilo({
      tipoAreaProfilo,
      descrizioneProfilo,
      hasGreenCompetence: isGreen,
      hasDigitalCompetence: isDigital
    }).subscribe({
      next: (response: any) => {
        this.tipologieArea = [...response.result];
        this.ordinaAree(); // Applica ordinamento dopo il filtro
      }
    })
  }

  // Metodo per ordinare le aree
  ordinaAree() {
    switch (this.tipoOrdinamento) {
      case 'id':
        // Ordina per ID numerico
        this.tipologieArea.sort((a: any, b: any) => a.id - b.id);
        break;

      case 'alfabetico':
        // Ordina alfabeticamente ignorando il numero iniziale
        this.tipologieArea.sort((a: any, b: any) => {
          // Rimuove il numero iniziale (es. "1. AGRICOLTURA..." -> "AGRICOLTURA...")
          const descA = a.descrizione.replace(/^\d+\.\s*/, '');
          const descB = b.descrizione.replace(/^\d+\.\s*/, '');
          return descA.localeCompare(descB, 'it');
        });
        break;
    }
  }

  showDetailProfilo(el: any) {
    this.dialog.open(DetailProfiloDialog, {
      data: {title: "Dettaglio profili", id: el.idProposta},
      height: '95%',
      width: '100%'
    });
  }

  showDetailCompetenza(el: any) {
    this.dialog.open(DetailCompetenzaDialog, {
      data: {title: "Dettaglio competenza", id: el.id},
      height: '95%',
      width: '100%'
    });

  }
}
